export default __webpack_public_path__ + "static/media/coletivo-4.0583fa6a.jpeg";